import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import VeeValidate from 'vee-validate'
import 'intersection-observer' // polyfill para Intersection Observer API
import VueObserveVisibility from 'vue-observe-visibility' // Intersection Observer API
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false
Vue.use(VeeValidate)
Vue.use(VueObserveVisibility)
Vue.use(VueAnalytics, {
  id: 'UA-100980959-3',
  router
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
